<template>
  <v-dialog
    max-width="500px"
    persistent
    :value="value"
  >
    <v-card>
      <v-card-title> Copy this template to another company </v-card-title>
      <v-card-text>
        <v-select
          v-model="company"
          dense
          outlined
          :items="companies"
          item-text="name"
          item-value="id"
          :loading="loading"
          return-object
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          class="blue white--text"
          @click="handleConfirm"
          >{{ $t("commons.ok") }}</v-btn
        >
        <v-btn
          color="error"
          @click="handleCancel"
          >{{ $t("commons.cancel") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AdminServices from "@/services/AdminServices"

export default {
  name: "AdminEditCompany",
  props: {
    selectedItem: {
      type: Object
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      company: this.selectedItem.company,
      companies: [],
      loading: false
    }
  },
  created() {
    this.fetchCompanies()
  },
  methods: {
    fetchCompanies() {
      this.loading = true
      AdminServices.getCompanies().then(response => {
        this.companies = response.results
        this.loading = false
      })
    },
    handleCancel() {
      this.$emit("cancel")
    },
    handleConfirm() {
      this.$emit("confirm", this.company)
    }
  }
}
</script>
